<div class="box" [ngClass]="{ yellowBox: yellowBox }">
  <div class="ltiCost">
    {{ 'ADMIN_LTI.LTI_COST.TITLE' | translate }}
    <span *ngIf="type === 'before' && (plan.IsActive || plan.IsReviewing)">
      | {{ 'ADMIN_LTI.TIME_PART.BODY.BEFORE_CHANGES' | translate }}
    </span>
    <span *ngIf="type === 'after' && (plan.IsActive || plan.IsReviewing)">
      | {{ 'ADMIN_LTI.TIME_PART.BODY.AFTER_CHANGES' | translate }}
    </span>
  </div>

  <tabset [justified]="true">
    <tab heading="{{ 'ADMIN_LTI.TOTAL' | translate }}">
      <div class="targetContainer display-flex-space-between">
        <div class="targetCaption">
          {{ 'ADMIN_LTI.LTI_COST.TARGET' | translate }}
        </div>
        <div class="targetValue">{{ getTargetValue(undefined) }}</div>
      </div>
      <div class="minContainer display-flex-space-between">
        <div class="minCaption" *ngIf="getMinValue(undefined)">
          {{ 'ADMIN_LTI.LTI_COST.MIN' | translate }}
        </div>
        <div class="minValue">{{ getMinValue(undefined) }}</div>
      </div>
      <div class="maxContainer display-flex-space-between">
        <div class="maxCaption" *ngIf="getMaxValue(undefined)">
          {{ 'ADMIN_LTI.LTI_COST.MAX' | translate }}
        </div>
        <div class="maxValue">{{ getMaxValue(undefined) }}</div>
      </div>
    </tab>
    <tab heading="{{ 'ADMIN_LTI.YEARLY' | translate }}">
      <div
        class="targetContainer display-flex-space-between"
        *ngIf="type === 'before'"
      >
        <div class="targetCaption">
          {{ 'ADMIN_LTI.LTI_COST.TARGET' | translate }}
        </div>
        <div class="targetValue">{{ getTargetValue(currentYear) }}</div>
      </div>
      <div
        class="minContainer display-flex-space-between"
        *ngIf="type === 'before'"
      >
        <div class="minCaption" *ngIf="getMinValue(currentYear)">
          {{ 'ADMIN_LTI.LTI_COST.MIN' | translate }}
        </div>
        <div class="minValue">{{ getMinValue(currentYear) }}</div>
      </div>
      <div
        class="maxContainer display-flex-space-between"
        *ngIf="type === 'before'"
      >
        <div class="maxCaption" *ngIf="getMaxValue(currentYear)">
          {{ 'ADMIN_LTI.LTI_COST.MAX' | translate }}
        </div>
        <div class="maxValue">{{ getMaxValue(currentYear) }}</div>
      </div>

      <accordion [closeOthers]="'true'" *ngIf="type !== 'before'">
        <accordion-group
          *ngFor="let year of plansLength()"
          (isOpenChange)="check($event)"
        >
          <button
            class="btn btn-link btn-block clearfix accordion-head"
            accordion-heading
            type="button"
          >
            <div class="pull-left float-left">{{ year }}</div>
            <span class="float-right pull-right">
              <i class="fa fa-caret-down"></i>
            </span>
          </button>

          <div class="targetContainer display-flex-space-between">
            <div class="targetCaption">
              {{ 'ADMIN_LTI.LTI_COST.TARGET' | translate }}
            </div>
            <div class="targetValue">{{ getTargetValue(year) }}</div>
          </div>
          <div class="minContainer display-flex-space-between">
            <div class="minCaption" *ngIf="getMinValue(year)">
              {{ 'ADMIN_LTI.LTI_COST.MIN' | translate }}
            </div>
            <div class="minValue">{{ getMinValue(year) }}</div>
          </div>
          <div class="maxContainer display-flex-space-between">
            <div class="maxCaption" *ngIf="getMaxValue(year)">
              {{ 'ADMIN_LTI.LTI_COST.MAX' | translate }}
            </div>
            <div class="maxValue">{{ getMaxValue(year) }}</div>
          </div>
        </accordion-group>
      </accordion>
    </tab>
  </tabset>
</div>
